import { Skeleton } from '../../../ds/components';
import { clsx } from '../../../ds/clsx';
import styles from './board.module.css';

/** Deal-Pipeline 14: six shimmering columns (five stages + the late group) while the board loads. */
export function BoardSkeleton({ mobile = false }: { mobile?: boolean | undefined }) {
  const columns = mobile ? [1] : [1, 2, 3, 4, 5, 6];
  const heights = [[96, 112], [112], [96, 96], [112], [96], [140]];
  return (
    <div className={styles.board} aria-busy="true" aria-label="Pipeline wird geladen">
      {columns.map((column, index) => (
        <div
          key={column}
          className={clsx(styles.column, index === 5 && styles.columnLate)}
          style={mobile ? { flex: '1 1 auto' } : undefined}
        >
          <div className={styles.columnHead}>
            <Skeleton width={index === 5 ? 82 : 92 + (index % 3) * 8} height={10} />
            <span className={styles.columnCount}>
              <Skeleton width={12} height={14} />
            </span>
          </div>
          <div className={styles.columnSub}>
            <Skeleton width={48} height={9} />
            <span className={styles.columnOwner}>
              <Skeleton width={44} height={9} />
            </span>
          </div>
          {(heights[index] ?? [96]).map((height, cardIndex) => (
            <div key={cardIndex} className={styles.skeletonCard} style={{ height }} />
          ))}
        </div>
      ))}
    </div>
  );
}
